import { FC } from 'react'
import { FilterItem } from '@/network/graphql.g'
import MobileFilterGridItem, {
  MobileFilterItemType
} from './mobileFilterGridItem'

type Props = {
  tags: FilterItem[]
  initialSelections: string[]
  updatePendingFilter: (ids: string[]) => void
}

const FilterTagsSlidePage: FC<Props> = ({
  tags = [],
  initialSelections,
  updatePendingFilter
}) => {
  const items: MobileFilterItemType[] = tags.map((i) => ({
    id: i.id,
    title: i.title,
    count: i.count
  }))

  return (
    <MobileFilterGridItem
      items={items}
      selectedIds={initialSelections}
      onSelectionChange={updatePendingFilter}
    />
  )
}
export default FilterTagsSlidePage
